import { useMutation, useQueryClient } from "@tanstack/react-query";
import serialsClient from "../../../api/serials";

const useAddTestSerialMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ serial, note }: { serial: string; note?: string }) =>
      serialsClient.addTestSerial(serial, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["serials", "test"] });
    },
  });
};

export default useAddTestSerialMutation;
